export default "__VITE_ASSET__CbuRSs2z__"